export default __webpack_public_path__ + "static/media/skill8.4ff3164d.svg";